import { formatUTCAtFixedOffset } from 'src/utilities/DateTimeUtilities';
import type { SnapshotTagRow } from 'src/components/star-grid/starGridTypes';

// Prophecy renders version-name timestamps at a fixed UTC-5 (snapshot_config.json timestamp_convention).
const PROPHECY_UTC_OFFSET_MINUTES = -5 * 60;

const PERIOD_PATTERNS: Readonly<Record<string, RegExp>> = {
  YYYYMM: /^\d{4}(0[1-9]|1[0-2])$/,
  YYYY: /^\d{4}$/,
  'YYYY Qn': /^\d{4} Q[1-4]$/
};

const PERIOD_EXAMPLES: Readonly<Record<string, string>> = { YYYYMM: '202608', YYYY: '2027', 'YYYY Qn': '2026 Q3' };

export const periodPlaceholder = (format: string | undefined): string => (format && PERIOD_EXAMPLES[format]) || '';

export const isValidPeriod = (period: string, format: string | undefined): boolean => {
  const pattern = format ? PERIOD_PATTERNS[format] : undefined;
  return pattern ? pattern.test(period.trim()) : period.trim().length > 0;
};

/** Prophecy's version name, `<period> <deck type> - <M/D/YY, h:mm AM>`, from the snapshot's UTC commit time. */
export const prophecyTagLabel = (deckType: string, period: string, committedAt: string | null | undefined): string =>
  deckType && period && committedAt
    ? `${period.trim()} ${deckType} - ${formatUTCAtFixedOffset(committedAt, PROPHECY_UTC_OFFSET_MINUTES, 'M/D/YY, h:mm A')}`
    : '';

// Tags created before labels existed carry none; their Iceberg name is all there is to show.
export const snapshotDisplayName = (row: Pick<SnapshotTagRow, 'tag' | 'label'>): string => row.label ?? row.tag ?? '';
